import { DirectorProfileButton } from 'containers/Director/Layout/Header/DirectorProfileButton';
import { HeaderWrapper } from 'containers/Header/HeaderWrapper';
import React from 'react';

interface Props {
  children?: React.ReactNode;
  noMobile?: boolean;
  withSubHeader?: boolean;
}

export function Header({ children, noMobile, withSubHeader }: Props) {
  return (
    <HeaderWrapper
      noMobile={noMobile}
      withSubHeader={withSubHeader}
      rightContent={<DirectorProfileButton />}
    >
      {children}
    </HeaderWrapper>
  );
}
